import { selectProjectState } from 'projectRedux/store';
import { plenumDataAdapter } from '../adapters/plenumDataAdapter';

export const {
  selectAll: selectAllPlenumdatas,
  selectById: selectPlenumdataById,
  selectEntities: selectPlenumdataEntities,
} = plenumDataAdapter.getSelectors((state) => selectProjectState(state).plenumdatas);
